import { LinkProtocol } from "../LinkProtocol";
import { DataFieldValue } from "./DataFieldValue";

export class LinkDataFieldValue extends DataFieldValue {

	public destination?: string;
	public protocol?: LinkProtocol;

	public static isLinkValue(value: DataFieldValue): value is LinkDataFieldValue {

		// Return Whether Value Is LinkDataFieldValue
		return (value as LinkDataFieldValue).destination !== undefined;
	}
}
